import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "@/lib/cn.ts";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string; error?: string; hint?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { label, error, hint, className, id, ...props }, ref,
) {
  const inputId = id ?? `input-${Math.random().toString(36).slice(2, 9)}`;
  return (
    <div className="flex flex-col gap-1">
      {label && <label htmlFor={inputId} className="text-[12px] font-medium text-surface-700">{label}</label>}
      <input
        ref={ref} id={inputId}
        className={cn(
          "h-9 rounded-lg border border-surface-200 bg-white px-3 text-[13px] text-surface-900",
          "placeholder:text-surface-400 focus:border-brand-500 focus:ring-2 focus:ring-brand-500/20 transition-colors",
          "disabled:cursor-not-allowed disabled:opacity-50",
          error && "border-danger focus:border-danger focus:ring-danger/20",
          className,
        )}
        {...props}
      />
      {hint && !error && <p className="text-[11px] text-surface-400">{hint}</p>}
      {error && <p className="text-[11px] text-danger">{error}</p>}
    </div>
  );
});
